const faTemperatureHalf = {
  prefix: 'fal',
  iconName: 'temperature-half',
  icon: [
    320,
    512,
    [127777, 'temperature-2', 'thermometer-2', 'thermometer-half'],
    'f2c9',
    'M160 32c-44.2 0-80 35.8-80 80l0 171.3c0 3.9-1.4 7.7-4 10.6-17.4 19.8-28 45.7-28 74.1 0 61.9 50.1 112 112 112s112-50.1 112-112c0-28.4-10.6-54.3-28-74.1-2.6-2.9-4-6.7-4-10.6L240 112c0-44.2-35.8-80-80-80zM48 112C48 50.1 98.1 0 160 0S272 50.1 272 112l0 165.5c20 24.7 32 56.2 32 90.5 0 79.5-64.5 144-144 144S16 447.5 16 368c0-34.3 12-65.8 32-90.5L48 112zM160 400c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm0 32c-35.3 0-64-28.7-64-64 0-29.8 20.4-54.9 48-62l0-82c0-8.8 7.2-16 16-16s16 7.2 16 16l0 82c27.6 7.1 48 32.2 48 62 0 35.3-28.7 64-64 64z',
  ],
};
export default faTemperatureHalf;
